/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type FgaUserState = typeof FgaUserState[keyof typeof FgaUserState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FgaUserState = {
  WAITING_FOR_ACTIVATION: 'WAITING_FOR_ACTIVATION',
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
} as const;
